import React from 'react';
import './styles/app.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './modules/home';

function App() {
  return (
    <div className="app">
      <div style={{ height: '0px' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
